import { AfterViewInit, Component, Injector, OnInit } from '@angular/core';
import { RoleType, UserGroupType } from 'tnx-admin-service/authorization/constants';
import { ModuleService } from 'tnx-admin-service/authorization/module/services';
import { PermissionService } from 'tnx-admin-service/authorization/permission/services';
import { UserGroupService } from 'tnx-admin-service/authorization/usergroup/services';
import { ComCtxConstants, ComponentContextService, DataListBase, DropdownControlSchema, Operator, TreeDataOption } from 'tnx-shared';
import { TreeNode } from 'tn-custom-primeng/api';

@Component({
    selector: 'app-user-permission-area',
    templateUrl: './user-permission-area.component.html',
    styleUrls: ['./user-permission-area.component.scss'],
    providers: [ComponentContextService]
})
export class UserPermissionAreaComponent extends DataListBase implements OnInit, AfterViewInit {
    searchSchema: any = {};
    searchData: any = {};
    submitting: any;
    countLoading: any;

    permissionEditable: any[];
    originalPermissionIds: any[];
    permissionIds: any[];
    moduleCode: any;
    functionTreeData: any;
    selectedTreeNode: any;
    isExpand = false;

    controlModule = new DropdownControlSchema({
        field: 'moduleCode',
        loadOnInit: true,
        baseService: this._moduleService,
        valueField: 'code',
        displayField: 'name',
        showClear: true
    });

    constructor(
        protected _injector: Injector,
        protected _userGroupService: UserGroupService,
        private _moduleService: ModuleService,
        private _permissionService: PermissionService
    ) {
        super(_injector);
    }

    ngOnInit() {
        this.setting.baseService = this._userGroupService;
        this.setting.objectName = 'nhóm người dùng';
        this.setting.popupSize.height = 700;
        this.setting.popupSize.width = 1000;

        this.parentContext.subscribe(ComCtxConstants.PERMISSION.SELECTED_OBJECT_CHANGED, async data => {
            if (!data.ids || data.ids.length == 0) {
                this.reset();
                return;
            }

            if (data.type == UserGroupType.User
                || data.type == UserGroupType.Client) {
                await this.onSelectedUser(data);
            }
            else {
                await this.onSelectedUserGroup(data);
            }

            this.getFunctionTree();
        });

        this.parentContext.subscribe(ComCtxConstants.PERMISSION.REFRESH_USER_PERMISSION, () => {
            // this.reload();
            this.reset();
        });
        this.reset();
        this.getFunctionTree();
        super.ngOnInit();
    }

    async onSelectedUser(data) {
        const allPermissionRequestModel = {
            idUsers: data.ids,
            roleType: null
        };
        const requestModel = {
            idUsers: data.ids,
            roleType: RoleType.Group
        };

        const permissionRes = await Promise.all([
            this._permissionService.GetIdByUsers(allPermissionRequestModel),
            this._permissionService.GetIdByUsers(requestModel),
            this._permissionService.GetIntersectDirectIdByUsers(data.ids),
        ]);
        const allPermissionResponse = permissionRes[0];
        const permissionAssignToGroupUser = permissionRes[1];
        const intersectDirectResponse = permissionRes[2];

        this.permissionEditable = intersectDirectResponse.data.filter(x => permissionAssignToGroupUser.data.every(k => k != x));
        this.originalPermissionIds = allPermissionResponse.data;
        this.permissionIds = [...allPermissionResponse.data];
    }

    async onSelectedUserGroup(data) {
        const allPermissionRequestModel = {
            idUserGroups: data.ids,
            userGroupType: null
        };

        const requestModel = {
            idUserGroups: data.ids,
            userGroupType: RoleType.Hidden
        };

        const permissionRes = await Promise.all([
            this._permissionService.GetIdByGroupUsers(allPermissionRequestModel),
            this._permissionService.GetIdByGroupUsers(requestModel),
            this._permissionService.GetIntersectDirectIdByGroupUsers(data.ids)
        ]);

        const allPermissionResponse = permissionRes[0];
        const permissionAssignToGroupUser = permissionRes[1];
        const intersectDirectResponse = permissionRes[1];

        this.permissionEditable = intersectDirectResponse.data.filter(x => permissionAssignToGroupUser.data.every(k => k != x));
        this.originalPermissionIds = allPermissionResponse.data;
        this.permissionIds = [...allPermissionResponse.data];
    }

    checkDisabled(node: TreeNode) {
        return node.data.disabled || (this.originalPermissionIds.includes(node.data.id) && !this.permissionEditable.includes(node.data.id));
    }

    expand(nodes) {
        this.isExpand = !this.isExpand;
        this.doExpand(nodes);
    }

    doExpand(nodes) {
        for (const node of nodes) {
            if (node.children) {
                node.expanded = this.isExpand;
                for (const cn of node.children) {
                    this.doExpand(node.children);
                }
            }
        }
    }

    reset() {
        this.permissionEditable = [];
        this.originalPermissionIds = [];
        this.permissionIds = [];

        this.parentModel.advanceData.permission = {
            addPermissionIds: [],
            removePermissionIds: []
        };

        this.getFunctionTree();
    }

    handleChangePhanHe(event) {
        this.getFunctionTree();
    }

    async getFunctionTree() {
        const filters = [];
        if (this.moduleCode) {
            filters.push(this.newFilter('moduleCode', Operator.equal, this.moduleCode));
        }

        const data = (await this._permissionService.getAll(filters)).data;
        data.forEach(element => {
            if (this.originalPermissionIds.find(x => x == element.id) != null) {
                element.status = 'checked';
            }
        });

        this.functionTreeData = this._crudService.getTreeDataWithOrder(data, 'idParent', 'orderNo', <TreeDataOption>{ displayField: 'name', shortDisplayField: 'name' }, null);
        this.appendKeyToTreeNode(this.functionTreeData);
        this.functionTreeData.forEach(x => {
            this.markCorssed(x);
        });
    }


    appendKeyToTreeNode(treeNodes, parentKey?) {
        treeNodes.forEach((node, i) => {
            node.expanded = this.isExpand;
            node.key = parentKey != null ? `${parentKey}_${i}` : `${i}`;
            if (node.children && node.children.length) {
                this.appendKeyToTreeNode(node.children, node.key);
            }
        });
    }

    doSearch() {
    }

    checkNode(node) {
        switch (node.data.status) {
            case 'crossed':
                node.data.status = 'checked';
                this.doCheckChildren(node);
                break;
            case 'checked':
                node.data.status = 'unchecked';
                this.removePermissionId(node.data.id);
                this.doUncheckChildrent(node);
                this.doUncheckParent(node);
                break;
            default:
                // if (node.children) {
                //     node.data.status = 'crossed';
                // }
                // else {
                node.data.status = 'checked';
                this.doCheckChildren(node);
                // }

                this.addPermissionId(node.data.id);
                this.doCheckParent(node);
        }

        const addPermission = this.permissionIds.filter(x => this.originalPermissionIds.every(k => k != x));
        const removePermission = this.permissionEditable.filter(x => this.permissionIds.every(k => k != x));

        this.parentModel.advanceData.permission = {
            addPermissionIds: addPermission,
            removePermissionIds: removePermission
        };
    }

    doCheckParent(node) {
        if (node.parent) {
            if (node.parent.children.find(x => x.data.status != 'checked') != null) {
                node.parent.data.status = 'crossed';
            }
            else {
                node.parent.data.status = 'checked';
            }

            this.addPermissionId(node.parent.data.id);
            this.doCheckParent(node.parent);
        }
    }


    doCheckChildren(node) {
        if (node.children) {
            node.children.forEach(child => {
                child.data.status = 'checked';
                this.addPermissionId(child.data.id);
                this.doCheckChildren(child);
            });
        }
    }

    doUncheckParent(node) {
        if (node.parent) {
            if (node.parent.children.some(x => x.data.status == 'checked' || x.data.status == 'crossed')) {
                node.parent.data.status = 'crossed';
            }
            else {
                node.parent.data.status = 'unchecked';
                this.removePermissionId(node.parent.data.id);
            }
            this.doUncheckParent(node.parent);

        }
    }

    doUncheckChildrent(node) {
        if (node.children) {
            node.children.forEach(child => {
                child.data.status = 'unchecked';
                this.removePermissionId(child.data.id);
                this.doUncheckChildrent(child);
            });
        }
    }

    addPermissionId(id) {
        if (!this.permissionIds.some(x => x == id)) {
            this.permissionIds.push(id);
        }
    }

    removePermissionId(id) {
        this.permissionIds = this.permissionIds.filter(x => x != id);
    }

    markCorssed(node) {
        if (node.data.status != 'checked') {
            return;
        }

        if (node.children) {
            node.children.forEach(child => {
                this.markCorssed(child);
            });

            if (node.children.some(x => x.data.status != 'checked')) {
                node.data.status = 'crossed';
            }

            if (node.children.some(x => x.data.disabled || (this.originalPermissionIds.includes(x.data.id) && !this.permissionEditable.includes(x.data.id)))) {
                node.data.disabled = true;
            }
        }
    }

}
